import { Zap, Plus, ChefHat } from 'lucide-react'
import type { ComponentType, SVGProps } from 'react'

type Tile = {
  label:      string
  Icon:       ComponentType<SVGProps<SVGSVGElement>>
  iconTint:   string
  iconColor:  string
  onClick:    () => void
}

type Props = {
  onQuickAdd: () => void
  onAddItem:  () => void
  onRecipe:   () => void
}

export function HomeActionTiles({ onQuickAdd, onAddItem, onRecipe }: Props) {
  const tiles: Tile[] = [
    {
      label:     'Quick add',
      Icon:      Zap,
      iconTint:  'bg-[#FBE8DB]',
      iconColor: 'text-terracotta',
      onClick:   onQuickAdd,
    },
    {
      label:     'Add item',
      Icon:      Plus,
      iconTint:  'bg-[#E0EBE2]',
      iconColor: 'text-forest',
      onClick:   onAddItem,
    },
    {
      label:     'Recipe',
      Icon:      ChefHat,
      iconTint:  'bg-[#FDF3E2]',
      iconColor: 'text-[#B5683A]',
      onClick:   onRecipe,
    },
  ]

  return (
    <div className="mb-6 grid grid-cols-3 gap-2">
      {tiles.map(({ label, Icon, iconTint, iconColor, onClick }) => (
        <button
          key={label}
          onClick={onClick}
          className="flex flex-col items-center rounded-[14px] border border-border-sand bg-paper px-2 py-[14px] transition-colors active:bg-cream-warm"
        >
          <div className={`mb-2 flex h-[34px] w-[34px] items-center justify-center rounded-[11px] ${iconTint}`}>
            <Icon className={`h-[18px] w-[18px] ${iconColor}`} strokeWidth={1.8} />
          </div>
          <div className="text-[12px] font-semibold tracking-[-0.01em] text-ink">{label}</div>
        </button>
      ))}
    </div>
  )
}
